import { Routes } from '@angular/router';
import { AuthCallback } from './auth/auth-callback';
import { authGuard } from './auth/auth.guard';

export const routes: Routes = [
  { path: 'auth/callback', component: AuthCallback },
  {
    path: '',
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [
      { path: '', pathMatch: 'full', children: [] },
      {
        path: 'quality-assurance/code-coverage',
        pathMatch: 'full',
        redirectTo: 'quality-assurance/repository-quality'
      },
      {
        path: 'quality-assurance/repository-quality',
        pathMatch: 'full',
        loadComponent: () =>
          import('./screens/repository-quality/repository-quality').then((module) => module.RepositoryQuality)
      },
      {
        path: 'automic/executions',
        pathMatch: 'full',
        loadComponent: () =>
          import('./screens/automic/automic-executions').then((module) => module.AutomicExecutions)
      },
      {
        path: 'automic',
        pathMatch: 'full',
        loadComponent: () => import('./screens/automic/automic-overview').then((module) => module.AutomicOverview)
      },
      {
        path: 'monitored-resources',
        loadComponent: () =>
          import('./screens/monitored-resources/monitored-resources').then(
            (module) => module.MonitoredResources
          )
      },
      {
        path: 'contact-search',
        loadComponent: () =>
          import('./screens/contact-search/contact-search').then((module) => module.ContactSearch)
      },
      {
        path: 'correlation-search',
        loadComponent: () =>
          import('./screens/correlation-search/correlation-search').then(
            (module) => module.CorrelationSearch
          )
      },
      {
        path: 'month-end',
        loadComponent: () => import('./screens/month-end/month-end').then((module) => module.MonthEnd)
      },
      {
        path: 'module/:id',
        loadComponent: () => import('./screens/url-host/url-host').then((module) => module.UrlHost)
      }
    ]
  }
];
